import { Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { DxTabsComponent } from 'devextreme-angular';
import { ActivatedRoute } from '@angular/router';
import { map, shareReplay } from 'rxjs/operators';
import { distinctUntilChanged } from 'rxjs';
import { AccessType, AuthService, PermissionType } from '@services';
import { InvoicePurchaseOrderHistoryComponent } from './invoice-purchase-order-history/invoice-purchase-order-history.component';
import { InvoicePurchaseOrderDetailsComponent } from './invoice-purchase-order-details/invoice-purchase-order-details.component';

type TabKey = 'details' | 'history';

@Component({
    selector: 'app-invoice-purchase-orders',
    imports: [
        AsyncPipe,
        DxTabsComponent,
        InvoicePurchaseOrderHistoryComponent,
        InvoicePurchaseOrderDetailsComponent,
    ],
    templateUrl: './invoice-purchase-order.component.html',
})
export class InvoicePurchaseOrderComponent {
    private route = inject(ActivatedRoute);
    private auth = inject(AuthService);

    get showDetails(): boolean {
        return this.auth.checkPermission(PermissionType.InvoicePurchaseOrderDetails, AccessType.ViewOnly);
    }

    get showHistory(): boolean {
        return this.auth.checkPermission(PermissionType.InvoicePurchaseOrderHistory, AccessType.ViewOnly);
    }

    selectedTab: TabKey = this.showDetails ? 'details' : 'history';

    readonly number$ = this.route.paramMap.pipe(
        map((params) => params.get('number')),
        distinctUntilChanged(),
        shareReplay(1),
    );

    allTabs = [
        { key: 'details', text: 'Details', icon: 'fas fa-info-circle', permission: PermissionType.InvoicePurchaseOrderDetails },
        { key: 'history', text: 'History', icon: 'fas fa-history', permission: PermissionType.InvoicePurchaseOrderHistory },
    ];

    tabs = this.allTabs.filter((t) => this.auth.checkPermission(t.permission, AccessType.ViewOnly));
}
